import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { IBodySurveyState } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { setAssessmentsList } from '../../../store/additionalAssessments.actions'
import { setBodValue, setSelectedBodyPartData } from '../store/bodySurvey.actions'

export function* saveBodySurvey() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)

  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const { findings, examValues, examValuesPNNVs, __selectedBodyParts, __documentFindings } = bodySurvey
      const combinedExamOptions = [...examValues, ...examValuesPNNVs]
      const filterExamValuesForLocations = combinedExamOptions?.filter((exam) =>
        __selectedBodyParts?.some((part) => part.id === exam.locationId)
      )
      const filterFindingsBasedOnLocation = findings?.filter(
        (exam) => __selectedBodyParts && __selectedBodyParts.some((part) => part.id === exam.locationId)
      )
      const allSelectedBodyPartsExamined = __selectedBodyParts.every((part) => part.isExamined)

      const deletedAllExams =
        filterExamValuesForLocations?.length === 0 &&
        filterFindingsBasedOnLocation?.length === 0 &&
        allSelectedBodyPartsExamined

      const updatedAssessments = (pcrDoc.additionalAssessment?.bodySurveys || []).map((assessment) => {
        if (assessment.seq === bodySurvey.seq) {
          return {
            ...assessment,
            ...bodySurvey,
          }
        }
        return assessment
      })

      const isSeqMatched = updatedAssessments.some((assessment) => assessment.seq === bodySurvey.seq)
      if (!isSeqMatched) {
        updatedAssessments.push({
          ...bodySurvey,
        })
      }

      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        additionalAssessment: {
          ...pcrDoc.additionalAssessment,
          bodySurveys: updatedAssessments,
        },
      }

      if (!__documentFindings && deletedAllExams) {
        yield put(setSelectedBodyPartData([]))
      }
      if (examValues.length > 0 || examValuesPNNVs.length > 0 || findings.length > 0) {
        yield put(setBodValue(true))
      }
      yield put(setAssessmentsList(updatedAssessments))
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveBodySurvey() error: ${e}`))
    }
  }
}

export function* saveBodySurveySaga() {
  yield takeLatest([BodySurveyConstants.SAVE_BODY_SURVEY_ASSESSMENT], performWithMutexHOG, saveBodySurvey)
}
